import { __awaiter } from "tslib";
import ApiManager from '@/managers/apimanagers';
import { decimalStep, priceDecimalStep } from './utils';
import { watch } from 'vue';
import { useStore } from '@/store/store';
import dayjs from 'dayjs';
import BigNumber from 'bignumber.js';
let unwatchChart;
export const useDatafeeds = (pair, base, currencies, currencyPairs) => {
    let chart = [];
    const store = useStore();
    const supported_resolutions = ['1', '5', '15', '60', '120', '240', '1440', 'W'];
    const datafeeds = {
        onReady: (callback) => {
            setTimeout(() => callback({ supported_resolutions }), 0);
        },
        searchSymbols: () => {
            console.log('searchSymbols');
        },
        resolveSymbol: (symbolName, onSymbolResolvedCallback) => {
            const step = priceDecimalStep(pair, currencyPairs);
            let digits = new BigNumber(1).div(new BigNumber(step)).toNumber();
            // Todo: Tradingviewのバグによるバグのため、ライブラリが発行されたらこの処理は削除する
            // https://github.com/tradingview/lightweight-charts/issues/55
            if (Math.log10(digits) === 5) {
                digits = 1000000;
            }
            setTimeout(() => {
                onSymbolResolvedCallback({
                    name: symbolName,
                    description: '',
                    type: 'crypto',
                    session: '24x7',
                    timezone: 'Etc/UTC',
                    minmov: 1,
                    pricescale: digits,
                    has_intraday: true,
                    has_empty_bars: true,
                    // force_session_rebuild: false,
                    // has_no_volume: true,
                    expired: false,
                    has_weekly_and_monthly: true,
                    intraday_multipliers: ['1', '5', '15', '60', '120', '240', '1440', 'W'],
                });
            }, 0);
        },
        getBars: (symbolInfo, resolution, periodParams, onResult, onError) => __awaiter(void 0, void 0, void 0, function* () {
            store.commit('setChartInterval', resolution);
            try {
                const backendModel = yield ApiManager.get(`/chart?pair=${symbolInfo.name}&term=${resolution}&from=${periodParams.from}&to=${periodParams.to}`);
                if (backendModel.length === 0) {
                    onResult([], {
                        noData: true,
                    });
                    return;
                }
                const scale = 1 / decimalStep(base, currencies);
                const existBars = backendModel.map((c) => {
                    return {
                        time: c.time,
                        open: parseFloat(c.open),
                        close: parseFloat(c.close),
                        high: parseFloat(c.high),
                        low: parseFloat(c.low),
                        volume: Math.floor(c.volume * scale),
                    };
                });
                chart = [...existBars];
                onResult(existBars, { noData: existBars.length < 1 });
            }
            catch (err) {
                onError(String(err));
            }
        }),
        subscribeBars: (symbolInfo, resolution, onTick) => __awaiter(void 0, void 0, void 0, function* () {
            const scale = 1 / decimalStep(base, currencies);
            unwatchChart = watch(() => store.state.latestCount, () => {
                const lastBar = chart.slice(-1)[0];
                if (lastBar) {
                    const bar = changeLastPriceBar(lastBar, scale, store.getters.chartInterval);
                    if (bar) {
                        chart.push(bar);
                        onTick(bar);
                    }
                }
            });
        }),
        unsubscribeBars: () => {
            if (unwatchChart) {
                unwatchChart();
            }
        },
    };
    const changeLastPriceBars = (chart, resolution, scale) => {
        const lastBar = chart.slice(-1)[0];
        const bar = changeLastPriceBar(lastBar, scale, resolution);
        if (bar) {
            chart.push(bar);
        }
        return { chart, bar };
    };
    const changeLastPriceBar = (lastBar, scale, resolution) => {
        const now = dayjs().unix() * 1000;
        const isHigher = lastBar.high < store.state.latestValue;
        const isLower = store.state.latestValue < lastBar.low;
        const diff = (now - Number(lastBar === null || lastBar === void 0 ? void 0 : lastBar.time)) / 1000 / 60;
        const isTimeChange = diff >= Number(resolution);
        if (isTimeChange) {
            const adjust = Math.floor(diff / Number(resolution));
            return {
                time: lastBar.time + Number(resolution) * 60 * 1000 * adjust,
                open: store.state.latestValue,
                close: store.state.latestValue,
                high: store.state.latestValue,
                low: store.state.latestValue,
                volume: store.state.latestAmount * scale,
            };
        }
        const bar = {
            time: lastBar.time,
            open: lastBar.open,
            close: store.state.latestValue,
            high: isHigher ? store.state.latestValue : lastBar.high,
            low: isLower ? store.state.latestValue : lastBar.low,
            volume: lastBar.volume + store.state.latestAmount * scale,
        };
        return bar;
    };
    return { datafeeds, changeLastPriceBars, changeLastPriceBar };
};
